export const isActionable = ({ isOwner, isAuthor, isReportable, isSpam })=>{
    return (isOwner || isAuthor || isReportable) && !isSpam;
};
export function canPeek(comment) {
    // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
    //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
    //         || ($is_author && $is_deleted); // author can see deleted
    if (comment.isOwner) {
        // owner can see owner-hidden
        if (comment.isHidden && !comment.isAdminHidden) {
            return true;
        }
        // and spam
        if (comment.isSpam) {
            return true;
        }
    }
    if (comment.isAuthor) {
        // comment author can see deleted
        if (comment.isDeleted) {
            return true;
        }
    }
    return false;
}
export function isCommentHidden({ isDeleted, isHidden, isAdminHidden, isSpam, replies }, isPeeking) {
    // these rules match those in CommentBody
    const isVisible = !isAdminHidden && !isDeleted;
    if (!isPeeking && isSpam && replies !== 0) {
        return true;
    }
    if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return true;
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return true;
    }
    return false;
}
export function getCommentNotificationQueue({ commentId }) {
    return `comment-${commentId}`;
}
export function generateReplyEditorId(comment) {
    return `reply-${comment.commentId}`;
}

//# sourceMappingURL=utils.js.map